<template>
    <PrismicLink v-if="isFilled.link(link)" :field="link" class="social-media-link">
        <InstagramIcon v-if="socialMedia === 'instagram'" />
        <FacebookIcon v-else-if="socialMedia === 'facebook'" />
        <LinkedinIcon v-else-if="socialMedia === 'linkedin'" />
        <YoutubeIcon v-else-if="socialMedia === 'youtube'" />
    </PrismicLink>
</template>
<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import type {LinkField} from '@prismicio/types';
    import {PrismicLink} from '@prismicio/vue';
    import FacebookIcon from '~/components/icons/Facebook.vue';
    import InstagramIcon from '~/components/icons/Instagram.vue';
    import LinkedinIcon from '~/components/icons/LinkedIn.vue';
    import YoutubeIcon from '~/components/icons/Youtube.vue';

    defineProps<{
        link: LinkField;
        socialMedia: 'facebook' | 'linkedin' | 'instagram' | 'twitter' | 'youtube';
    }>();
</script>

<style lang="scss">
    .social-media-link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: var(--joy-core-radius-6);
        border: 1px solid var(--joy-color-primary-50);
        transition: all var(--joy-transition-duration-default) var(--joy-transition-timing-function);
        &:hover {
            background-color: var(--joy-color-primary-10);
        }
    }
</style>
